<template>
  <div class="footer">
    <footer class="frame-footer">
      <ul class="address-information">
        <li class="contact-item icon-phone">
          <a href="tel:19930383437">技术支持：19930383437/刘经理</a>
        </li>
        <li class="contact-item presale-section icon-mobile">
          <div class="presale-wrap">
            <p class="presale-label">售前咨询：</p>
            <div class="presale-qrcode-list">
              <div class="presale-qrcode-item">
                <img src="~@/../static/img/e1ae6c50a0e7560fa51ca97bdfda1a8d.png" alt="售前咨询 张经理">
              </div>
              <div class="presale-qrcode-item">
                <img src="~@/../static/img/709bf22738ac678eb9c72cd33870ad48.png" alt="售前咨询 吴经理">
              </div>
            </div>
          </div>
        </li>
        <li class="contact-item icon-building">北京元新科技有限公司</li>
        <li class="contact-item icon-location">总公司：北京市海淀区花园桥世纪经贸大厦A座</li>
        <li class="contact-item no-icon">分公司：衡水市桃城区育才街站前西路翡翠华府一区1—4</li>
      </ul>
      <ul class="nav">
        <li :class="{'router-link-exact-active':active == 1 }" @click="link('index',1)">首页</li>
        <li :class="{'router-link-exact-active':active == 2 }" @click="link('classselection',2)">校园管理平台</li>
        <li :class="{'router-link-exact-active':active == 3 }" @click="link('campuspaymen',3)">招生缴费系统</li>
        <li :class="{'router-link-exact-active':active == 4 }" @click="link('classcard',4)">校园一脸通</li>
        <li :class="{'router-link-exact-active':active == 5 }" @click="link('homeschool',5)">智慧校园AIOT硬件</li>
         <li :class="{'router-link-exact-active':active == 6 }" @click="link('smarteducational',6)">服务</li>
        
       
        <li :class="{'router-link-exact-active':active == 7 }" @click="link('companyprofile',7)">案例</li>
        <li :class="{'router-link-exact-active':active == 8 }" @click="link('businesscooperation',8)">关于凡高</li>

        <!-- <li :class="{'router-link-exact-active':active == 1 }" @click="link('index',1)">首页</li>
        <li :class="{'router-link-exact-active':active == 2 }" @click="link('classselection',2)">新高考选排课</li>
        <li :class="{'router-link-exact-active':active == 3 }" @click="link('campuspaymen',3)">校园缴费</li>
        <li :class="{'router-link-exact-active':active == 4 }" @click="link('classcard',4)">智慧班牌</li>
        <li :class="{'router-link-exact-active':active == 5 }" @click="link('homeschool',5)">家校互联</li>
        <li :class="{'router-link-exact-active':active == 6 }" @click="link('smarteducational',6)">智慧教务</li>
        <li :class="{'router-link-exact-active':active == 7 }" @click="link('companyprofile',7)">公司简介</li>
        <li :class="{'router-link-exact-active':active == 8 }" @click="link('businesscooperation',8)">商务合作</li> -->
      </ul>
      <p style="padding: 15px 0px; text-align: center;">北京元新科技有限公司 版权所有 京ICP备12022765号-7</p></footer>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "",
      data: "",
      show: false,
      active: "1"
    };
  },
  components: {},
  mounted() {
    this.active = localStorage.active;
  },
  methods: {
    link(name, n) {
      localStorage.active = n;
      this.$router.push({ name: name, params: {} });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.frame-footer {
  padding: 0 5%;
  background: #444;
  color: #fff;
  font-size: 12px;
}

.frame-footer .address-information {
  padding: 40px 0 35px;
  border-bottom: 1px solid #dedede;
}

.frame-footer .address-information > li {
  display: flex;
  align-items: flex-start;
  margin-top: 32px;
  padding-left: 40px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 1.5;
  background-repeat: no-repeat;
  background-size: 30px 30px;
  background-position: left center;
}

.frame-footer .address-information > li:first-child {
  margin-top: 0;
}

.frame-footer .address-information .icon-phone {
  background-image: url("~@/../static/img/icon-1.png");
}

.frame-footer .address-information .icon-mobile {
  background-image: url("~@/../static/img/icon-2.png");
}

.frame-footer .address-information .presale-section {
  flex-direction: column;
  padding-left: 40px;
  padding-right: 0;
  background-position: left top;
}

.frame-footer .address-information .presale-wrap {
  width: 100%;
}

.frame-footer .address-information .presale-label {
  margin: 0 0 0.32rem;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 1.5;
}

.frame-footer .address-information .presale-qrcode-list {
  display: flex;
  justify-content: space-between;
  gap: 0.32rem;
  width: 100%;
}

.frame-footer .address-information .presale-qrcode-item {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 0.12rem;
  overflow: hidden;
}

.frame-footer .address-information .presale-qrcode-item img {
  display: block;
  width: 100%;
  height: auto;
}

@media screen and (min-width: 768px) {
  .frame-footer .address-information .presale-wrap {
    display: flex;
    align-items: flex-start;
    gap: 20px;
  }

  .frame-footer .address-information .presale-label {
    margin: 0;
    flex-shrink: 0;
    line-height: 30px;
    white-space: nowrap;
  }

  .frame-footer .address-information .presale-qrcode-list {
    width: auto;
    flex: 1;
    justify-content: flex-start;
    gap: 24px;
  }

  .frame-footer .address-information .presale-qrcode-item {
    flex: none;
    width: 150px;
    max-width: 150px;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .frame-footer .address-information .presale-qrcode-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  }
}

.frame-footer .address-information .icon-building {
  background-image: url("~@/../static/img/icon-3.png");
}

.frame-footer .address-information .icon-location {
  background-image: url("~@/../static/img/icon-4.png");
}

.frame-footer .address-information .no-icon {
  padding-left: 40px;
  background-image: none;
}

.frame-footer .address-information .contact-item a {
  color: #fff;
  text-decoration: none;
}

.frame-footer .nav {
  padding: 20px 0;
  border-bottom: 1px solid #dedede;

  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  /* line-height:21px; */
}

.frame-footer .nav > li:not(:first-child) {
  /* margin-top: 15px; */
  margin-top: 28px;
}

.router-link-active.router-link-exact-active {
  color: #2ab1f3;
}
.router-link-exact-active {
  color: #2ab1f3;
}
p {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue